import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useModal } from '../../../hooks/useModal';
import { formatSeconds } from '../../../utils';
import { AvatarGroup } from '../../Avatars';
import { DotList } from '../../Structure';
import { CollaboratorsByline } from './CollaboratorsByline';
import { CollaboratorsModal } from './CollaboratorsModal';
const Wrapper = styled.div `
    display: flex;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
`;
const CollectionDurationAndAuthorSection = styled.div `
    text-align: start;
    ${(props) => (props.$hasCollaborators ? 'margin-left: 1rem;' : null)}
`;
const CollectionDateAndDuration = styled(Typography) `
    margin-right: 1rem;
`;
export const Collaborators = ({ collaborators, createdAt, estimatedSecondsToConsume, numSkillsText, onCollaboratorClick, parentTitle }) => {
    const { modalOpen, handleModalOpen, handleModalClose } = useModal();
    return (React.createElement(Wrapper, null,
        React.createElement(AvatarGroup, { users: collaborators }),
        React.createElement(CollaboratorsModal, { onClick: onCollaboratorClick, collaborators: collaborators, open: modalOpen, onClose: handleModalClose, parentTitle: parentTitle }),
        React.createElement(CollectionDurationAndAuthorSection, { "$hasCollaborators": collaborators.length > 0 },
            React.createElement(CollaboratorsByline, { collaborators: collaborators, handleCollaboratorsModalOpen: handleModalOpen }),
            React.createElement(CollectionDateAndDuration, { variant: "body2" },
                React.createElement(DotList, null,
                    formatSeconds(estimatedSecondsToConsume, 'medium'),
                    numSkillsText,
                    createdAt)))));
};
//# sourceMappingURL=Collaborators.js.map